var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPositive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#45B39C"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M511.904 259.723L386.213 134.059L386.16 134.006L378.693 126.539C377.093 124.939 375.44 123.392 373.786 121.952C364.346 113.525 355.653 107.552 353.466 109.792L323.279 139.979L311.919 151.339L127.28 335.925C125.947 337.258 125.36 339.178 125.467 341.258C125.467 341.258 125.467 341.258 125.414 341.311L115.334 374.271L109.574 392.991C108.827 395.284 109.947 397.898 111.761 399.818L111.974 400.031L221.526 509.62C232.805 511.141 244.299 512 256 512C396.139 512 509.909 399.381 511.904 259.723Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2070_18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.063 197.667H108.563C100.509 197.667 93.9795 204.196 93.9795 212.25V372.667C93.9795 380.721 100.509 387.25 108.563 387.25H196.063C204.117 387.25 210.646 380.721 210.646 372.667V212.25C210.646 204.196 204.117 197.667 196.063 197.667Z",
    fill: "#38B1E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.542 198.906H401.834C406.223 198.903 410.557 199.891 414.511 201.797C418.466 203.702 421.939 206.475 424.673 209.909C427.407 213.344 429.33 217.351 430.299 221.632C431.268 225.914 431.259 230.358 430.271 234.635L403.584 350.062C402.099 356.491 398.479 362.227 393.314 366.332C388.149 370.438 381.744 372.671 375.146 372.667H263.292C261.065 372.662 258.852 372.318 256.729 371.646L210.354 357.062V230.844L220.417 228.292C222.138 227.741 223.593 226.572 224.5 225.01L258.115 167.26C258.77 166.106 259.098 164.795 259.063 163.469C259.063 156.177 258.261 131.167 261.323 122.781C264.896 112.865 297.782 94.9271 317.469 135.323C337.157 175.719 317.469 197.375 317.469 197.375L317.542 198.906Z",
    fill: "#FAC591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.896 358.083C174.95 358.083 181.479 351.554 181.479 343.5C181.479 335.446 174.95 328.917 166.896 328.917C158.842 328.917 152.312 335.446 152.312 343.5C152.312 351.554 158.842 358.083 166.896 358.083Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2070_18"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 350,
    fill: "white",
    transform: "translate(81 81)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPositive);
export default __webpack_public_path__ + "static/media/positive.6701f662fb703048ecb9410733c06eb8.svg";
export { ForwardRef as ReactComponent };